import React from 'react';
import { Skeleton } from '@mui/material';

const SKELETON_SX = { bgcolor: '#F9F7F4', borderRadius: '6px' };

const SkeletonJobCard = ({ isAdmin }) => {
  return (
    <div
      className={`box-border flex w-full flex-col items-start self-stretch
        min-h-[115px] tabletH:min-h-[180px]
        gap-4 tabletH:gap-8
        px-3 py-[14px] tabletH:p-6
        rounded-[20px] tabletH:rounded-[30px]
        bg-grayscale-gray00 ${
          isAdmin ? 'border border-grayscale-gray02' : 'border-[1.6px] border-grayscale-gray02'
        }`}
    >
      <div className='flex w-full items-start gap-2 tabletH:gap-4'>
        <Skeleton
          variant='rectangular'
          sx={{ ...SKELETON_SX, borderRadius: '8px' }}
          className='!size-[50px] shrink-0 tabletH:!size-[72px]'
        />

        <div className='flex min-w-0 flex-[1_0_0] flex-col justify-center gap-2 tabletH:gap-4 min-h-[50px] tabletH:min-h-[72px]'>
          <Skeleton
            variant='rectangular'
            sx={SKELETON_SX}
            className='!h-[20px] w-full max-w-[300px] tabletH:!h-[30px]'
          />
          <Skeleton
            variant='rectangular'
            sx={SKELETON_SX}
            className='!h-[14px] w-2/3 max-w-[300px] tabletH:!h-[18px]'
          />
        </div>
      </div>

      <div className='flex w-full flex-row flex-wrap content-start items-start gap-2'>
        <Skeleton
          variant='rectangular'
          sx={SKELETON_SX}
          className='!h-[14px] w-1/2 max-w-[300px] tabletH:!h-[18px]'
        />
      </div>
    </div>
  );
};

export default SkeletonJobCard;
